import { MonitorIcon } from './MonitorIcon';

/**
 * author: Google
 * id 35091AEB-2AF7-4F92-A249-2955F01404A3
 * name monitor
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/monitor.svg
 * tags
 * - Device / Tech 
 */
export const DesktopWindowsIcon = MonitorIcon;
export default DesktopWindowsIcon